import {createSlice} from '@reduxjs/toolkit';
import AccountAction from '../actions/AccountAction';
import CommonUtil from '../common/CommonUtil';
import forEach from 'lodash/forEach';
import get from 'lodash/get';
import { createSelector } from 'reselect';
/**
 * LayoutTemplateSlice use for build reducer
 * Store data layout
 * Author: Oliver.Nguyen
 */
export const LayoutTemplateSlice = createSlice({
    name: 'LayoutTemplateSlice',
    initialState: {
        templateData: {},
        currentPageContainer: 'sportPageContainer',
        currentViewContainer: 'compactView',
        env: {},
        isWait: true,
        fixed: {
            header: '',
            body: ''
        },
        hasLiveTVEvent: true,
        hasLiveCenterEvent: true,
        isSmallLayout: window.innerWidth <= 1024,
        isNavLoaded: false
    },
    reducers: {
        updateTemplateData: (state, {payload}) => {
            state.templateData = payload;
        },
        updateHasLiveTV: (state, {payload}) => {
          state.hasLiveTVEvent = payload;
        },
        updateHasCenterEvent: (state, {payload}) => {
            state.hasLiveCenterEvent = payload;
          },
        updateCurrentPageContainer: (state, {payload}) => {
            state.currentPageContainer = payload;
            if (state.currentPageContainer !== CommonUtil.getCurrentPage()) {
                CommonUtil.saveCookie('currentPage', payload, {path: "/", domain: AccountAction.getSubDomain()})
            }
        },
        updateCurrentViewContainer: (state, {payload}) => {
            state.currentViewContainer = payload;
        },
        updateIsWaitLoading: (state, {payload}) => {
            state.isWait = payload;
        },
        setFixed: (state, {payload}) => {
            if (!payload) {
                return
            }
            forEach(payload, (value, key) => {
                state.fixed[key] = payload[key];
            })
        },
        updateIsSmallLayout: (state, {payload}) => {
            state.isSmallLayout = payload;
        },
        updateIsNavLoaded: (state, {payload}) => {
            state.isNavLoaded = payload;
        }
    },
});

export const isVsPageSelector = state => {
    return state.LayoutTemplateSlice.currentPageContainer === 'vsPageContainer';
}

export const isChangePasswordPageSelector = state => {
    return state.LayoutTemplateSlice.currentPageContainer === 'changePasswordContainer';
}

export const isCasinoPageSelector = state => {
    return state.currentPageContainer === 'casinoPageContainer' || state.currentPageContainer === 'liveCasinoPageContainer';
}

export const isHomePageSelector = state => {
    return state.LayoutTemplateSlice.currentPageContainer === 'homePageContainer';
}

export const enableCloudflareImgCaching = createSelector(
  state => state.LayoutTemplateSlice.templateData.attributes,
  attributes => get(attributes, 'enableCloudflareImgCaching', false)
)

export const bannerCloudflareCachingUrl = createSelector(
  state => state.LayoutTemplateSlice.templateData.attributes,
  attributes => get(attributes, 'bannerCloudflareCachingUrl', '')
)

export default LayoutTemplateSlice.reducer;


// WEBPACK FOOTER //
// ./src/app/slices/LayoutTemplateSlice.js